import { Grid, Button } from '@mui/material';
import { BackIcon } from 'components/SVG';
import ForwardIcon from 'components/SVG/ForwardIcon';
import React from 'react';
import { SparkFormButton } from 'sharedComponents/SparkForm';

type FooterProps = {
  activeStep: number;
  handleBack?: () => void;
  isLastStep: boolean;
  isParentLoading?: boolean;
  isFirstStep?: boolean;
};

function Footer({
  activeStep,
  handleBack,
  isLastStep,
  isParentLoading,
  isFirstStep,
}: FooterProps) {
  return (
    <Grid
      item
      sx={{
        display: 'flex',
        justifyContent: isFirstStep ? 'flex-end' : 'space-between',
        width: '100%',
      }}
    >
      {!isFirstStep && (
        <Button
          disabled={isParentLoading}
          onClick={handleBack}
          sx={{
            height: '45px',
            width: '45px',
            aspectRatio: 1,
            borderRadius: '14px',
            borderColor: '#EEEEEE',
            padding: 2,
          }}
          variant='outlined'
        >
          <BackIcon />
        </Button>
      )}

      <SparkFormButton
        fullWidth={false}
        endIcon={<ForwardIcon />}
        sx={{ padding: 2, height: '45px', borderRadius: '8px' }}
        disabled={isParentLoading}
      >
        {isLastStep ? 'Finish' : 'Next'}
      </SparkFormButton>
    </Grid>
  );
}

export default Footer;
